var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('img',{staticClass:"tooltip__icon",attrs:{"src":_vm.InfoIconSVG}}),_c('span',{staticClass:"tooltip__content"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }